'use client';

import { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { Button } from '@/elements/button/button.component';
import { SubscribeButton } from '@/elements/subscribe-button/subscribe-button.component';
import { Container, Overlay, Contents, Section } from './mobile-menu.elements';

import izvrsnostLogo from '@/assets/img/izvrsnost-logo.png';

const MobileMenu = ({ opened, pathname, user, handleLogIn, handleLogout }) => {
  useEffect(() => {
    if (opened) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '8px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = 0;
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = 0;
    };
  }, [opened]);

  return (
    <Container $opened={opened} onClick={(e) => e.preventDefault()}>
      <Overlay />
      <Contents>
        <Link href="/" style={{ margin: '0 auto' }}>
          <Image src={izvrsnostLogo} height={56} alt="Inkubator izvrsnosti logo" />
        </Link>
        <Section>
          <Link href="/edukacije">
            <Button outline width="100%">
              Edukacije
            </Button>
          </Link>
          <Link href="/predavaci">
            <Button outline width="100%">
              Predavači
            </Button>
          </Link>
          <Link href="/blog">
            <Button outline width="100%">
              Blog
            </Button>
          </Link>
          <Link href="/novosti">
            <Button outline width="100%">
              Novosti
            </Button>
          </Link>
          <Link href="/daruj-edukaciju">
            <Button outline width="100%">
              Daruj edukaciju
            </Button>
          </Link>
          <Link href="/o-nama">
            <Button outline width="100%">
              O nama
            </Button>
          </Link>
          <Link href="/kontakt">
            <Button outline width="100%">
              Kontakt
            </Button>
          </Link>
        </Section>

        <Section>
          {!['/pretplata', '/prijava-na-edukaciju'].includes(pathname) &&
          (!user || (user.roles.includes('student') && !user.subscriptionStartedAt)) ? (
            <Link href="/pretplata">
              <SubscribeButton>Pretplati se</SubscribeButton>
            </Link>
          ) : null}

          {user ? (
            !pathname.includes('moj-profil') ? (
              <Link href="/moj-profil">
                <Button outline width="100%">
                  Moj profil
                </Button>
              </Link>
            ) : null
          ) : !['/prijava', '/registracija'].includes(pathname) ? (
            <div>
              <Button outline width="100%" onClick={handleLogIn}>
                Prijavi se
              </Button>
            </div>
          ) : null}

          {user?.roles.some((role) => ['superadmin', 'admin'].includes(role)) ? (
            <Link href="/konzola">
              <Button outline width="100%" color="red">
                Konzola
              </Button>
            </Link>
          ) : null}
          {user?.roles.some((role) =>
            ['superadmin', 'admin', 'lecturer', 'editor'].includes(role)
          ) ? (
            <Link href="/admin">
              <Button outline width="100%" color="lagoon">
                CMS
              </Button>
            </Link>
          ) : null}

          {user ? (
            <div>
              <Button naked width="100%" onClick={handleLogout}>
                Odjavi se
              </Button>
            </div>
          ) : null}
        </Section>
      </Contents>
    </Container>
  );
};

export { MobileMenu };
